// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"e96825e9cbc3fe9a2060","293":"f980e0a8a6c7dbc29942"}[chunkId] + ".js";
};